<template>
  <div class="distribution ">
    <el-row class="distribution-map">
      <el-col :span="24">
        <!-- 地图 -->
        <div class="map" id='readmeMap'></div>
      </el-col>
    </el-row>
   <!-- <div class="distribution-title font20">
      当前位置：新能源监管 > 三级物流节点
    </div> -->
    <div class="container w1400">
      <div class="handle-box">
        <el-button type="success" icon="search" @click="getWith(3)">末端共同配送站基本信息 {{count3}}个</el-button>
        <el-button type="info" icon="search" @click="getWith(2)">公共配送中心基本信息 {{count2}}个</el-button>
        <el-button type="warning" class="btn2" icon="search" @click="getWith(1)">干支衔接型货运枢纽基本信息 {{count1}}个</el-button>
      </div>
      <el-table border style="width: 100%" :data="withData" ref="multipleTable">
        <el-table-column prop="aa004" label="枢纽名称" />
        <el-table-column prop="aa005" label="地址" />
        <el-table-column prop="aa006" label="所属商业区或工业区" />
        <el-table-column prop="aa007" label="建设情况">
          <template slot-scope="scope">
            <el-tag :type="scope.row.aa007==1?'success':'danger'">{{scope.row.aa007==1?'已完成':'未完成'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="aa008" label="建设主体" />
        <el-table-column prop="aa009" label="联系人" />
        <el-table-column prop="aa010" label="联系电话" />
      </el-table>
      <div class="el-pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="count">
        </el-pagination>
      </div>
    </div>
    <MapWay :drawer.sync='drawer' :destination='itemClick'></MapWay>
  </div>
</template>

<script>
  import MapWay from "../common/mapWay.vue"
  import Gmap from "../../public/Gmap";
  export default {
    mixins:[Gmap],
    components:{
      MapWay,
    },
    data() {
      return {
        //路线弹窗
        drawer:false,
        itemClick:[],
        //map
        map: '',
        markers: [],
        withData: [],
        count: 0,
        count1: 0,
        count2: 0,
        count3: 0,
        currentPage: 1, //当前页数
        pageSize: 10, //当前每页显示多少,
        type: 3
      }
    },
    mounted() {
      this.initMap();
      this.getWith(3);

      (async ()=>{
        let num = await this.getlength();
        let data = await this.getWithAll(num);
        data.forEach((ele,i)=>{
          ele.aa013 = ele.aa013.split(",")
          let respone  = this.initMarker(ele, i);
          this.initMapInfo(respone,ele);
        })
      })();
    },
    methods: {
      initMarker(postion,ind) {
        // 创建一个 Icon
        let icon = new AMap.Icon({
          size: new AMap.Size(24, 30),
          // 图标的取图地址
          image: postion.aa003==3?'http://file.sywlfz.com/sylink/Images/terminalStation.png':(postion.aa003==1?'http://file.sywlfz.com/sylink/Images/mainStation.png':'http://file.sywlfz.com/sylink/Images/centerStation.png'),
          // 图标所用图片大小
          imageSize: new AMap.Size(24, 30),
        });
        let markerContent =`<div style='position:relative;'>
                                  <img src='http://file.sywlfz.com/sylink/Images/rechargeStation.png' style='width:24px;height:30px;' />
                                  <span style='color:#a52a2a;position:absolute;left:10px;top:-15px;'>${ind}</span>
                            </div>`;
        //自定义marker
        let marker = new AMap.Marker({
          map: this.map,
          position: postion.aa013,
          icon: icon,
          // content:markerContent,
          // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
          offset: new AMap.Pixel(-13, -30),
          // content:markerContent
        });
        this.markers.push(marker);
        //添加maerkers 到地图
        this.map.add([marker]);
        return marker;
      },
      initMapInfo(marker, info) {
        //实例化信息窗体
        let infoWindow = new AMap.InfoWindow({
          isCustom: true, //使用自定义窗体
          content: createInfoWindow(info),
          offset: new AMap.Pixel(16, -45)
        });
        //鼠标点击marker弹出自定义的信息窗体
        AMap.event.addListener(marker, 'mouseover', () => {
          infoWindow.open(this.map, marker.getPosition());
        });
        AMap.event.addListener(marker, 'click', () => {
          console.log(info)
          this.itemClick = info.aa013;
          this.drawer = true;
        });
        AMap.event.addListener(marker, 'mouseout', () => {
          this.map.clearInfoWindow();
        });
        //构建自定义信息窗体
        function createInfoWindow(content) {
          let href;
          if (Array.isArray(content.tg011) && content.tg011.length == 2) {
            href = `https://gaode.com/regeo?lng=${content.tg011[0]}&lat=${content.tg011[1]}&name=&adcode=`;
          } else {
            href = "https://gaode.com/regeo?lng=110.79&lat=32.65&name=&adcode=";
          }
          let info = document.createElement("div");
          info.style.backgroundColor = "#F8F8F8";
          info.style.width = '318px';
          info.style.borderRadius = '0 0 4px 4px';
          info.style.marginBottom = '-25px';
          //init title
          info.innerHTML =
            `
                    <div class="carinfo" style="display: flex;flex-wrap: nowrap;align-items: center;padding: 10px 0 7px 8px;">
                        <div style='font-size: 14px; color: #666;height:83px display: flex;flex-direction: column;align-content: space-between;'>
                            <div style='margin-bottom: 8px;'>名称:<span style="font-weight: 700">${content.aa004}</span></div>
                            <div style='margin-bottom: 8px;'>位置:${content.aa005}</div>
                            <div style='margin-bottom: 8px;'>联系电话:${content.aa010?content.aa010:''}</div>
                            <div style='margin-bottom: 8px;'>状态:<span style="font-weight: 700">${content.aa012==1?'正常服务':content.aa012==1?'停止服务':'已拆除'}</span></div>
                             <a href="${href}" target="_blank">点击此处导航(或者点击小图标)</a>
                        </div>
                    </div>`;

          return info;
        }
      },
      getWith(type) {
        this.type = type;
        let url = `/api/terminalStation/list/${type}`
        return new Promise((resolve,reject)=>{
          this.$axios.post(url, {
            skip: this.currentPage * this.pageSize - this.pageSize,
            pageSize: this.pageSize,
          }).then(res=>{
            if (res.data.code != 200)
             return this.$message({
              type: 'error',
              message: '请求出错'
            })
            else
              this.withData = res.data.data,
              this.count = res.data.count;
              resolve(res.data.data)
          })
        })
      },
      getWithAll(num) {
        return new Promise((resolve,reject)=>{
          this.$axios.post("/api/terminalStation/list", {
            skip: 0,
            pageSize: num || 100,
            where:' and isdelete=0 '
          }).then(res=>{
              resolve(res.data.data)
          })
        })
      },
      handleSizeChange(e) {
        this.pageSize = e
        this.getWith(this.type)
      },
      handleCurrentChange(e) {
        this.currentPage = e
        this.getWith(this.type)
      },
      getlength() {
        return new Promise((resolve,reject)=>{
          this.$axios.post('/api/terminalStation/typeCount', {
            where:' and isDelete=0'
          }).then(res => {
            this.count1 = res.data.data[0]
            this.count2 = res.data.data[1]
            this.count3 = res.data.data[2]
            resolve(this.count1+this.count2+this.count3);
          })
        })
      },
    }
  }
</script>

<style scoped>
  .distribution {
    width: 100%;
    color: #333333;
  }

  .map {
    width: 100%;
    height: 77.1rem;
  }
  .distribution-title {
    box-sizing: border-box;
    height: 7rem;
    line-height: 7rem;
    padding-left: 2.7rem;
    background-color: #F6F5F5;
  }

  .container {
    overflow: hidden;
    padding: 0 7.4rem;
    background-color: #F6F5F5;
  }

  .handle-box {
    margin: 4.3rem auto;
    display: flex;
    justify-content: space-between;

  }

  .pagination {
    display: flex;
    justify-content: center;
  }

  .el-pagination {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/distribution.vue